import styles from './Footer.module.css'

export function Footer() {
  return (
    <footer className={styles.root}>
      &copy; {new Date().getFullYear()} Taxfyle. All rights reserved.
    </footer>
  )
}
